import React, { useState } from 'react';
import MiscUtils from 'services/MiscUtils';
import ConfirmAuthenticationDialog from 'components/Misc/ConfirmAuthenticationDialog/index';
import { ResponsiveMediaCard } from 'services/UIUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import StaffUtils, {PERMISSIONS} from "services/StaffUtils";

var linkRef = React.createRef();

const ExportPatients = (props) => {
  const dispatch = useAppDispatch();
  const permissions = useAppSelector((state) => state.authentication.permissions);
  let [credentialsModal, setCredentialsModal] = useState(false);
  let [loading, setLoading] = useState(false);

  async function exportPatientsWrapper(auth) {
    setCredentialsModal(false);
    setLoading(true);
    const result = await dispatch(api.Patients.exportPatients({ authentication: auth }), {
      errorTitle: 'Export Patients',
    });
    setLoading(false);
    if (result) {
      downloadFile(result);
    }
  }

  function downloadFile(data) {
    let url = MiscUtils.getBlobUrl(data);
    const a = linkRef.current;
    a.download = 'patients_export.csv';
    a.href = url;
    a.click();
    a.href = '';
  }

  return (
    <React.Fragment>
      <a href="careand.ca" style={{ display: 'none' }} ref={linkRef}>
        Download
      </a>
      <ConfirmAuthenticationDialog
        onSubmit={exportPatientsWrapper}
        submitTitle="Authenticate & Export"
        onRequestClose={() => setCredentialsModal(false)}
        isOpen={credentialsModal}
      />
      <ResponsiveMediaCard
        title="Export Patients"
        text="Get a CSV with all the patients' information"
        img="users"
        onClick={() => setCredentialsModal(true)}
        loading={loading}
        allowed={StaffUtils.checkPermissions(permissions, [
          PERMISSIONS.super_admin,
        ])}
      />
    </React.Fragment>
  );
};

export default ExportPatients;
